import { Nullable } from '@bybeam/platform-types';
import dayjs, { type Dayjs } from 'dayjs';
const { isDayjs } = dayjs;

type SorterValue = Nullable<string | Date | Dayjs | number>;

// TODO: is better typing possible
export interface Sorter<T, Value = SorterValue> {
  accessor: (item: T) => Value;
  ascending?: boolean;
  nullishLast?: boolean;
}

function compare<T, Value>(
  item1: T,
  item2: T,
  { accessor, ascending = true, nullishLast = true }: Sorter<T, Value>,
): number {
  const prop1 = accessor(item1);
  const prop2 = accessor(item2);

  let comparison: number;
  if ((!prop1 && prop1 !== 0) || (!prop2 && prop2 !== 0)) {
    // biome-ignore lint/suspicious/noExplicitAny: used to allow toString
    comparison = ((prop1 as any) ?? '')
      .toString()
      // biome-ignore lint/suspicious/noExplicitAny: used to allow toString
      .localeCompare(((prop2 as any) ?? '').toString());
    if (nullishLast) comparison = -comparison;
  } else if (typeof prop1 === 'string' && typeof prop2 === 'string') {
    comparison = prop1.localeCompare(prop2);
  } else if (isDayjs(prop1) && isDayjs(prop2)) {
    comparison = prop1.unix() - prop2.unix();
  } else if (typeof prop1 === 'number' && typeof prop2 === 'number') {
    comparison = prop1 - prop2;
  } else {
    // biome-ignore lint/suspicious/noExplicitAny: used to allow toString
    comparison = (item1 as any).toString().localeCompare((item2 as any).toString());
  }
  return comparison * (ascending ? 1 : -1);
}

export default function sort<T>(arr: T[], ...sorters: Sorter<T>[]): T[] {
  return [...arr].sort((item1, item2) => {
    for (const sorter of sorters) {
      const comparison = compare(item1, item2, sorter);
      if (comparison) return comparison;
    }
    return 0;
  });
}
